import { Component, OnInit, Inject } from '@angular/core';
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import { AuthService } from './../auth/auth.service';
import { Observable } from 'rxjs';
import { Router } from '@angular/router';

@Component({
  selector: 'app-dialog-overview-example-dialog',
  templateUrl: './dialog-overview-example-dialog.component.html',
  styleUrls: ['./dialog-overview-example-dialog.component.css'],
})
export class DialogOverviewExampleDialogComponent implements OnInit {
  newToggleEditable: string | boolean;
  cubase = true;
  newcustDaylight: string;
  newcustBaseWwr: string;
  newcustBaseLighting: string;
  newcustBaseShading: string;
  newcustBaseWindow: string;
  newcustBaseFloor: string;
  newcustBase: string;
  newcustBaseRoof: string;
  custBaseHvac: any;
  newcustHtRec: string;
  newcustHvac: string;
  newisEditable: string;
  newIskpi: boolean = false;
  toggleBool: boolean = true;
  showTedi : boolean = false;
  showEnergy : boolean = true;
  costChart:string;
  baselineDefn : any;
  ashrae : any;
  necb : any;
  cb : any;
  cbEnabled: any;
  necbEnabled: any;
  ashraeEnabled: any;

  constructor(
    private authService: AuthService,
    private router: Router,
    public dialogRef: MatDialogRef<DialogOverviewExampleDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data
  ) {
    //dialogRef.disableClose = true;
    this.newIskpi = data.isCost;
  }
  getCost() {
    if (this.newisEditable == 'false') {
      if ((document.getElementById('ashr') as HTMLInputElement).checked) {
        this.authService.changeAshNecb('Ashare');
      } else if (
        (document.getElementById('necb') as HTMLInputElement).checked
      ) {
        this.authService.changeAshNecb('Necb');
      } else if (
        (document.getElementById('baseline') as HTMLInputElement).checked
      ) {
        this.authService.changeAshNecb('noash');
      }
      //this.authService.gtvalFirst();
	   if(this.costChart == 'Yes') {
		if ((document.getElementById('euikwh') as HTMLInputElement).checked) {
			this.authService.addtoKpiList('eui');
		}
		if ((document.getElementById('sav') as HTMLInputElement).checked) {
			this.authService.addtoKpiList('savings');
		}
		if ((document.getElementById('tedi') as HTMLInputElement).checked) {
			this.authService.addtoKpiList('tedi');
		}
	  } else if(this.costChart == 'No'){
		if ((document.getElementById('euikwh') as HTMLInputElement).checked) {
			this.authService.addtoKpiList('eui');
		}
		if ((document.getElementById('sav') as HTMLInputElement).checked) {
			this.authService.addtoKpiList('savings');
		}
		if ((document.getElementById('cp') as HTMLInputElement).checked) {
		  this.authService.addtoKpiList('cp');
		}
		if ((document.getElementById('ghg') as HTMLInputElement).checked) {
		  this.authService.addtoKpiList('ghg');
		}
		if ((document.getElementById('op') as HTMLInputElement).checked) {
		  this.authService.addtoKpiList('op');
		}
		if ((document.getElementById('pp') as HTMLInputElement).checked) {
		  this.authService.addtoKpiList('pp');
		}
		if ((document.getElementById('tedi') as HTMLInputElement).checked) {
			this.authService.addtoKpiList('tedi');
		} 
		if ((document.getElementById('tc') as HTMLInputElement).checked) {
			this.authService.addtoKpiList('tc');
		} 
	  }

      this.router.navigate(['chart']);
      this.dialogRef.close();
    } else if (this.newisEditable == 'true') {
      this.goBack();
    }
  }

  changeEvent(event) {
	  if ((document.getElementById('euikwh') as HTMLInputElement).checked) {
		(document.getElementById('sav') as HTMLInputElement).checked = true;
	} else {
		(document.getElementById('sav') as HTMLInputElement).checked = false;
	}
	if ((!(document.getElementById('euikwh') as HTMLInputElement).checked && !(document.getElementById('sav') as HTMLInputElement).checked && !(document.getElementById('tedi') as HTMLInputElement).checked)
      || (!(document.getElementById('ashr') as HTMLInputElement).checked && !(document.getElementById('necb') as HTMLInputElement).checked &&
      !(document.getElementById('baseline') as HTMLInputElement).checked)){
		this.toggleBool = true;
	} else {
		this.toggleBool = false;
	}
	
  }
  changeCostEvent(event) {
    if ((document.getElementById('euikwh') as HTMLInputElement).checked) {
      (document.getElementById('sav') as HTMLInputElement).checked = true;
    } else {
      (document.getElementById('sav') as HTMLInputElement).checked = false;
    }
	if ((!(document.getElementById('euikwh') as HTMLInputElement).checked && !(document.getElementById('sav') as HTMLInputElement).checked && !(document.getElementById('tedi') as HTMLInputElement).checked && !(document.getElementById('cp') as HTMLInputElement).checked && !(document.getElementById('ghg') as HTMLInputElement).checked && !(document.getElementById('op') as HTMLInputElement).checked && !(document.getElementById('pp') as HTMLInputElement).checked && !(document.getElementById('tc') as HTMLInputElement).checked)
    || (!(document.getElementById('ashr') as HTMLInputElement).checked && !(document.getElementById('necb') as HTMLInputElement).checked &&
    !(document.getElementById('baseline') as HTMLInputElement).checked)){
		this.toggleBool = true;
	} else {
		this.toggleBool = false;
	}
  }
  goBack() {
    this.dialogRef.close();
  }
  ngOnInit() {
    this.authService.currentcustBaseDaylight.subscribe(
      (newcustDaylight) => (this.newcustDaylight = newcustDaylight)
    );

    this.authService.currentcustBaseWwr.subscribe(
      (newcustBaseWwr) => (this.newcustBaseWwr = newcustBaseWwr)
    );

    this.authService.currentcustBaseLighting.subscribe(
      (newcustBaseLighting) => (this.newcustBaseLighting = newcustBaseLighting)
    );

    this.authService.currentcustBaseShading.subscribe(
      (newcustBaseShading) => (this.newcustBaseShading = newcustBaseShading)
    );

    this.authService.currentcustBaseWindow.subscribe(
      (newcustBaseWindow) => (this.newcustBaseWindow = newcustBaseWindow)
    );

    this.authService.currentcustBaseFloor.subscribe(
      (newcustBaseFloor) => (this.newcustBaseFloor = newcustBaseFloor)
    );

    this.authService.currentcustBase.subscribe(
      (newcustBase) => (this.newcustBase = newcustBase)
    );

    this.authService.currentcustBaseHvac.subscribe(
      (newcustHvac) => (this.newcustHvac = newcustHvac)
    );

    this.authService.currentcustBaseHtRec.subscribe(
      (newcustHtRec) => (this.newcustHtRec = newcustHtRec)
    );

    this.authService.currentcustBaseRoof.subscribe(
      (newcustBaseRoof) => (this.newcustBaseRoof = newcustBaseRoof)
    );

    this.authService.currentisEditable.subscribe(
      (newisEditable) => (this.newisEditable = newisEditable)
    );

    this.newToggleEditable = false;
    this.authService.currentToggleEditable.subscribe(
      (newToggleEditable) => (this.newToggleEditable = newToggleEditable)
    );
	this.authService.currentShowTedi.subscribe(
      (showTedi) => (this.showTedi = showTedi)
    );
	
	this.authService.currentShowEnergy.subscribe(
      (showEnergy) => (this.showEnergy = showEnergy)
    );
	
	this.authService.currenchartBeCost.subscribe(
      (costChart) => (this.costChart = costChart)
    );


    if (!this.newToggleEditable) {
      this.cubase = true;
    }
    if (this.newToggleEditable) {
      this.cubase = true;
    }
		this.authService.baselineDefnData().subscribe((data) => { 
		this.baselineDefn = data.projLists;
		
		this.ashrae = this.baselineDefn[0].ashrae;
		this.necb = this.baselineDefn[0].necb;
		this.cb = this.baselineDefn[0].cb;
		this.ashraeEnabled = this.baselineDefn[1].ashrae;
		this.necbEnabled = this.baselineDefn[1].necb;
		this.cbEnabled = this.baselineDefn[1].cb;
		
	 })
	if(this.showEnergy) {
		(document.getElementById('euikwh') as HTMLInputElement).checked = true;
		(document.getElementById('sav') as HTMLInputElement).checked = true;
	}
	

	
  }
}
export interface DialogData {
  animal: string;
  name: string;
}
